/*
 * @Author: 
 * @Date: 2022-03-08 08:50:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-27 10:51:01
 * @FilePath: /Cup2Market/src/views/GoodsDetail/webApi.js
 * @Description: 
 */
import request from "@/utils/request";

export function getGoodsDetail(id) {
  return request({
    url: "/product/goods/h5/goods-details/" + id,
    method: "get",
  });
}
export function addCart(data) {
  return request({
    url: "/trade/purchase/add",
    method: "post",
    data,
  });
}
export function getCouponCenter(params) {
  return request({
    url: "/product/coupon/center",
    method: "get",
    params,
  });
}
export function getCoupon(id) {
  return request({
    url: "/product/coupon/get-coupon/" + id,
    method: "put",
  });
}

// /product/goods/preview/G6944852061538942977?key=82u3peV6


export function getPreviewGoodsDetail(paramsObj) {
  // paramsObj 中的id 是商品未上架的时候的 id 
  // 类似这样的 G6944852061538942977
  // key 是后台生成的一个 key  用于过期的
  return request({
    url: `/product/goods/preview/${paramsObj.id}?key=${paramsObj.key}`,
    method: "get",
  });
}
